import { Component, OnInit, OnDestroy } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { DomService } from 'app/components/dom/dom.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuExhibitorSubMenuService } from 'app/components/menu-exhibitor-sub-menu/menu-exhibitor-sub-menu.service';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';
import { RolesService } from 'app/components/roles/roles.service';
import { ModalYesNoComponent } from 'app/components/modal-yes-no/modal-yes-no.component';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CONSTANTS } from 'environments/common';


@Component({
  selector: 'app-exhibitor-backoffice-exhibitors',
  templateUrl: './exhibitor-backoffice-exhibitors.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitors.component.css']
})
export class ExhibitorBackofficeExhibitorsComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  exhibitors: Array<any> = [];
  exhibitorStatuses: Array<any> = [];

  page: number = 1;
  pageSize: number = 10;
  filter: string = '';

  catalogueName: string|null = null;

  roles: object = CONSTANTS.ROLES;

  constructor(public catalogueService: CatalogueService, private domService: DomService, private exhitorsService: ExhitorsService,
    public utilsService: UtilsService, private activatedRoute: ActivatedRoute, private router: Router, private menuExhibitorSubMenuService: MenuExhibitorSubMenuService,
    public rolesService: RolesService, private catalogueUserService: CatalogueUserService, private modalService: NgbModal) {
    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || null;
  }


  getProfiles(getProfilesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getProfiles(getProfilesIn)
      .subscribe((data: object) => {
        this.getProfilesOk(data);
      },
        error => {
          this.getProfilesError(error);
        });

  }

  getProfilesOk(data) {

    this.loader.count--;
    this.exhibitors = data;

  }

  getProfilesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  filterElements() {
    if (!this.filter) {
      return this.exhibitors;
    } else {
      const filterText = this.filter.toLowerCase();
      
      return this.exhibitors.filter(obj => {
        const name = obj.name?.toLowerCase() || '';
        const sapId = obj.sapInfo?.id?.toLowerCase() || '';
        const standLocation = obj.standLocation?.toLowerCase() || '';
        const sapOrderId = obj.sapInfo?.orderId?.toLowerCase() || '';

        return name.includes(filterText) 
          || sapId.includes(filterText) 
          || standLocation.includes(filterText) 
          || sapOrderId.includes(filterText);
      });
    }
  }

  goTo(exhibitor) {
    this.menuExhibitorSubMenuService.setData(exhibitor);
    let url = '/' + this.catalogueName + '/exhibitor-backoffice/exhibitors/' + exhibitor.id + '/exhibitor-detail';
    if(this.rolesService.hasRoles(['ROLE_SDA_ADMIN', 'ROLE_BACKOFFICE_SUPERADMIN']))
      url = '/' + this.catalogueName + '/exhibitor-backoffice/exhibitors/' + exhibitor.id + '/exhibitor-detail-admin';
    this.router.navigate([url]);
  }

  createExhibitor() {
    let url = '/' + this.catalogueName + '/exhibitor-backoffice/exhibitors/exhibitor-create';
    this.router.navigate([url]);
  }

  importExhibitors() {
    let url = '/' + this.catalogueName + '/exhibitor-backoffice/exhibitors/import';
    this.router.navigate([url]);
  }

  getStatuses() {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getStatuses()
      .subscribe((data: object) => {
        this.getStatusesOk(data);
      },
        error => {
          this.getStatusesError(error);
        });

  }

  getStatusesOk(data) {
    this.loader.count--;
    this.exhibitorStatuses = data._embedded.exhibitorStatus;
  }

  getStatusesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getStatusObject(statusId) {
    for (let i = 0; i < this.exhibitorStatuses.length; i++) {
      if (this.exhibitorStatuses[i].id === statusId) {
        return this.exhibitorStatuses[i];
      }
    }
  }

  getExhibitorsByCatalogueUserId(getExhibitorsByCatalogueUserIdIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueUserService.getExhibitorsByCatalogueUserId(getExhibitorsByCatalogueUserIdIn)
      .subscribe((data: object) => {
        this.getExhibitorsByCatalogueUserIdOk(data);
      },
        error => {
          this.getExhibitorsByCatalogueUserIdError(error);
        });

  }

  getExhibitorsByCatalogueUserIdOk(data) {

    this.loader.count--;
    this.exhibitors = data;

    if (this.exhibitors.length === 1) {
      this.goTo(this.exhibitors[0]);
    }

  }

  getExhibitorsByCatalogueUserIdError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  publishAllExhibitors(publishAllExhibitorsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.publishAllExhibitors(publishAllExhibitorsIn)
      .subscribe((data: object) => {
        this.publishAllExhibitorsOk(data);
      },
        error => {
          this.publishAllExhibitorsError(error);
        });

  }

  publishAllExhibitorsOk(data) {
    this.loader.count--;
    this.getExhibitors();
  }

  publishAllExhibitorsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  publishAllExhibitorsBtn() {

    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'MODAL_YES_NO.PUBLISH_ALL_EXHIBITORS';

    modalRef.result.then( (option) => {

      if (option === 'yes') {

        let publishAllExhibitorsIn = {
          catalogueId: this.catalogueService.getProperty('id')
        }

        this.publishAllExhibitors(publishAllExhibitorsIn);

      }

    });

  }

  unpublishAllExhibitors(unpublishAllExhibitorsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.unpublishAllExhibitors(unpublishAllExhibitorsIn)
      .subscribe((data: object) => {
        this.unpublishAllExhibitorsOk(data);
      },
        error => {
          this.unpublishAllExhibitorsError(error);
        });

  }

  unpublishAllExhibitorsOk(data) {
    this.loader.count--;
    this.getExhibitors();
  }

  unpublishAllExhibitorsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  unpublishAllExhibitorsBtn() {

    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'MODAL_YES_NO.UNPUBLISH_ALL_EXHIBITORS';

    modalRef.result.then( (option) => {

      if (option === 'yes') {

        let unpublishAllExhibitorsIn = {
          catalogueId: this.catalogueService.getProperty('id')
        }

        this.unpublishAllExhibitors(unpublishAllExhibitorsIn);

      }

    });

  }

  getExhibitors() {

    if (this.rolesService.isSingleExhibitor() || this.rolesService.isMultipleExhibitor()) {

      let getExhibitorsByCatalogueUserIdIn = {
        catalogueUserId: this.catalogueUserService.getProperty('id'),
        eventName: this.catalogueService.getProperty('eventName')
      }

      this.getExhibitorsByCatalogueUserId(getExhibitorsByCatalogueUserIdIn);

    } else {

      let getProfilesIn = {
        catalogueId: this.catalogueService.getProperty('id')
      }

      this.getProfiles(getProfilesIn);
    }

  }

  ngOnInit() {

    this.domService.addClassToBody('bg-gray');

    this.getStatuses();
    this.getExhibitors();

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
